import * as React from 'react';



export default class Edit extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
       <g id="exzeo_2.x_icon_set" fillRule="evenodd" transform="translate(-112.000000, -225.000000)">
            <g id="Group-69" transform="translate(112.000000, 225.000000)">
                <g id="Page-1" transform="translate(2.000000, 2.000000)">
                    <path d="M5.20944,6.74082 L0.44964,11.50002" id="Stroke-1"></path>
                    <path d="M11.49978,0.44988 L6.74058,5.20968" id="Stroke-3"></path>
                    <polyline id="Stroke-5" points="8.24784 0.44988 11.49984 0.44988 11.49984 3.39948"></polyline>
                    <polyline id="Stroke-7" points="3.70212 11.44236 0.45012 11.44236 0.45012 8.49336"></polyline>
                </g>
            </g>
        </g>
      </svg>
    )
  }
}
